export const recentlyVisited = "/recently_visited";
